export class createRol {
    id: number;
    nombre: String;
    idEstado: number
    Estado: String;
    descripcion: String;
    permisos: Array<number>;
    grupos: Array<number>;
}